"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".imageAttachContainer[_ngcontent-%COMP%]{background-color:#f8f8f8;border:1px dashed #e9e9e9}.imageAttachContainer__fileArea[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:1;width:180px;height:200px;margin:5px;border:3px dotted #999;float:left}.mat-card-base[_ngcontent-%COMP%]{width:100%;height:140px;margin:auto;background-position:center;background-size:contain;background-repeat:no-repeat;position:relative}input[type=file][_ngcontent-%COMP%]{width:200px;z-index:1}input[type=file][_ngcontent-%COMP%]:before{content:\"Upload Picture(s)\"}"];
exports.styles = styles;
